/* =====================================================================
   KeenTrove Animasyon Kiti JS (Concept tema 4.3.0 portu)
   Kaynak elementler: 2-ayiklanmis/elementler/*.js ve yardimcilar/theme.*.js
   Bağımlılık: window.Motion (Motion One 10.16.2, vendor.js'in ilk ~40 KB'ı)
               window.Splitting (1.1.0) yalnızca <kt-split-words> için.
   Durum: HENÜZ TEST EDİLMEDİ, uygulama turunda taslak temada denenecek.
   Mantık Concept ile birebir; sadece isimler kt- ön ekli, Shopify.designMode
   dalları ve theme.* yardımcıları buraya gömüldü.
   ===================================================================== */
(() => {
  const config = {
    motionReduced: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    isTouch: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
    mqlSmall: window.matchMedia('screen and (max-width: 749px)').matches, // Dawn kırılımı (Kural 20)
    buttonHover: document.body.getAttribute('data-button-hover') !== 'none',
    titleAnimation: document.body.hasAttribute('data-title-animation'),
  };
  document.documentElement.classList.add(config.isTouch ? 'touch' : 'no-touch');
  document.documentElement.classList.replace('no-js', 'js');
  if (!window.Motion) { document.documentElement.classList.add('kt-ready'); document.querySelectorAll('.kt-invisible').forEach((e) => e.classList.remove('kt-invisible')); return; }

  const throttle = (cb) => { let id = null, args; return (...a) => { args = a; if (id === null) id = requestAnimationFrame(() => { id = null; cb(...args); }); }; };
  const imageLoaded = (imgs) => Promise.all(Array.from(imgs).map((img) => new Promise((res) => {
    (img.tagName === 'IMG' && img.complete) || !img.offsetParent ? res() : (img.onload = () => res());
  })));
  // Dokunmatikte ağır işleri ilk etkileşime (veya 5 sn) kadar erteler (Concept initWhenVisible)
  class InitWhenVisible {
    constructor(cb, delay = 5000) {
      this.cb = cb; this.done = false;
      this.ev = ['click', 'mousemove', 'keydown', 'touchstart', 'touchmove', 'wheel'];
      this.h = () => { if (this.done) return; this.done = true; this.cb(); this.ev.forEach((e) => window.removeEventListener(e, this.h)); clearTimeout(this.t); };
      this.ev.forEach((e) => window.addEventListener(e, this.h, { passive: true }));
      this.t = setTimeout(this.h, delay);
    }
  }
  const EASE = [.16, 1, .3, 1];

  /* ---------- 1. Scroll reveal: <kt-animate data-animate="fade-up|fade-up-large|fade-in|zoom-out" data-animate-delay="250"> ---------- */
  class Animation {
    constructor(el) { this.el = el; }
    get type() { return this.el.getAttribute('data-animate') || 'fade-up'; }
    get delay() { return (parseInt(this.el.getAttribute('data-animate-delay')) || 0) / 1000; }
    get media() { return Array.from(this.el.querySelectorAll('img, iframe, svg')); }
    beforeLoad() {
      const el = this.el, z = { duration: 0 };
      switch (this.type) {
        case 'fade-in': Motion.animate(el, { opacity: 0 }, z); break;
        case 'fade-up': Motion.animate(el, { transform: 'translateY(min(2rem, 90%))', opacity: 0 }, z); break;
        case 'fade-up-large': Motion.animate(el, { transform: 'translateY(90%)', opacity: 0 }, z); break;
        case 'zoom-out': Motion.animate(el, { transform: 'scale(1.3)' }, z); break;
        case 'zoom-out-media': if (this.media.length) Motion.animate(this.media, { transform: 'scale(1.3)' }, z); break;
      }
    }
    async load() {
      const el = this.el, o = (d) => ({ duration: d, delay: this.delay, easing: EASE });
      switch (this.type) {
        case 'fade-in': await Motion.animate(el, { opacity: 1 }, o(1.5)).finished; break;
        case 'fade-up': await Motion.animate(el, { transform: 'translateY(0)', opacity: 1 }, o(1.5)).finished; break;
        case 'fade-up-large': await Motion.animate(el, { transform: 'translateY(0)', opacity: 1 }, o(1)).finished; break;
        case 'zoom-out': await Motion.animate(el, { transform: 'scale(1)' }, o(1.3)).finished; break;
        case 'zoom-out-media': if (this.media.length) await Motion.animate(this.media, { transform: 'scale(1)' }, o(1.3)).finished; break;
      }
      el.classList.add('animate');
    }
  }
  class KtAnimate extends HTMLElement {
    connectedCallback() {
      if (config.motionReduced) return;
      this.animation = new Animation(this);
      this.animation.beforeLoad();
      Motion.inView(this, async () => { await imageLoaded(this.animation.media); this.animation.load(); });
    }
  }
  customElements.define('kt-animate', KtAnimate);

  /* ---------- 2. Başlık kelime kelime: <kt-split-words class="kt-split-words kt-invisible" data-animate="fade-up-large" data-animate-delay="250">Başlık</kt-split-words> ---------- */
  class KtSplitWords extends HTMLElement {
    connectedCallback() {
      if (config.motionReduced || !config.titleAnimation || !window.Splitting) { this.classList.remove('kt-invisible'); return; }
      const base = parseInt(this.getAttribute('data-animate-delay')) || 0;
      Splitting({ target: this, by: 'words' })[0].words.forEach((word, i) => {
        const w = document.createElement('kt-animate');
        w.className = 'block';
        w.setAttribute('data-animate', this.getAttribute('data-animate') || 'fade-up-large');
        w.setAttribute('data-animate-delay', base + i * 30); // her kelime +30 ms
        while (word.firstChild) w.appendChild(word.firstChild);
        word.appendChild(w);
      });
      this.classList.remove('kt-invisible');
    }
  }
  customElements.define('kt-split-words', KtSplitWords);

  /* ---------- 3. Liste/grid kademeli giriş: <kt-motion-list> içindeki .card'lar ---------- */
  class KtMotionList extends HTMLElement {
    constructor() {
      super();
      this.isMobile = config.mqlSmall || config.isTouch;
      if (config.motionReduced || this.hasAttribute('initialized')) return;
      this.unload(); Motion.inView(this, () => this.load());
    }
    get items() { const c = this.querySelectorAll('.card'); return Array.from(c.length ? c : this.querySelectorAll('.card-wrapper')); }
    params() { return { distance: this.isMobile ? 30 : 50, duration: this.isMobile ? .3 : .5, stagger: this.isMobile ? .05 : .1 }; }
    split(items) { const h = window.innerHeight + window.scrollY, v = [], iv = []; items.forEach((i) => { const r = i.getBoundingClientRect(); (r.top < h && r.bottom > 0 ? v : iv).push(i); }); return { v, iv }; }
    unload() { Motion.animate(this.items, { y: this.params().distance, opacity: 0, visibility: 'hidden' }, { duration: 0 }); }
    async load() {
      const { distance, duration, stagger } = this.params(), { v, iv } = this.split(this.items);
      await Motion.animate(v, { y: [distance, 0], opacity: [0, 1], visibility: ['hidden', 'visible'] }, { duration, delay: Motion.stagger(stagger) }).finished;
      Motion.animate(iv, { y: [distance, 0], opacity: [0, 1], visibility: ['hidden', 'visible'] }, { duration });
      this.items.forEach((i) => i.style.removeProperty('transform'));
      this.setAttribute('initialized', '');
    }
  }
  customElements.define('kt-motion-list', KtMotionList);

  /* ---------- 4. Buton dolgu hover (btn-fill) + mıknatıs ---------- */
  class HoverFill {
    constructor(el) { this.el = el; }
    get fill() { return this.el.querySelector('[data-fill]'); }
    load() {
      if (config.isTouch || !config.buttonHover) return;
      this.el.addEventListener('mouseenter', () => this.fill && Motion.animate(this.fill, { y: ['76%', '0%'] }, { duration: .6 }));
      this.el.addEventListener('mouseleave', () => this.fill && Motion.animate(this.fill, { y: '-76%' }, { duration: .6 }));
    }
  }
  class Magnet {
    constructor(el) { this.el = el; this.m = parseInt(el.getAttribute('data-magnet')) || 10; }
    get text() { return this.el.querySelector('[data-text]'); }
    load() {
      if (config.isTouch || !config.buttonHover || config.motionReduced || this.m === 0) return;
      const target = () => this.text || this.el, spring = { duration: 1.5, easing: Motion.spring() };
      this.el.addEventListener('mousemove', (e) => {
        const b = this.el.getBoundingClientRect();
        Motion.animate(target(), { x: ((e.clientX - b.left) / this.el.offsetWidth - .5) * this.m, y: ((e.clientY - b.top) / this.el.offsetHeight - .5) * this.m }, spring);
      });
      this.el.addEventListener('mouseleave', () => Motion.animate(target(), { x: 0, y: 0 }, spring));
    }
  }
  // Safari customized built-in (is="") desteklemediği için sınıf tabanlı başlatma:
  // <a class="button kt-hover"><span class="kt-btn-fill" data-fill></span><span class="kt-btn-text">…</span></a>
  // mıknatıs için ek: data-magnet="10" ; vurgu için: <em class="kt-highlight">…<svg/></em>
  // Faz 1: tüm .button'lara dolgu span'ı otomatik eklenir (uygulama blokları hariç)
  const FILL_EXCLUDE = '.shopify-payment-button, [class*="kaching"], [class*="Kaching"], .klaviyo-form, .judgeme, .jdgm-widget, .shopify-challenge__button';
  const injectFill = (root = document) => {
    root.querySelectorAll('.button:not(.kt-hover):not(.kt-no-fill):not(input)').forEach((el) => {
      if (el.closest(FILL_EXCLUDE) || el.querySelector('.kt-btn-fill')) return;
      const f = document.createElement('span'); f.className = 'kt-btn-fill'; f.setAttribute('data-fill', ''); f.setAttribute('aria-hidden', 'true');
      el.insertBefore(f, el.firstChild); el.classList.add('kt-hover');
    });
  };
  const initReveal = (root = document) => {
    if (config.motionReduced) return;
    // Ürün sayfası custom-liquid içerik satırları (ocx-*/ocxl-*/ktg-*): şablon JSON'una dokunmadan otomatik reveal
    // Faz 4: oc-lp-* (ayak/eldiven), track order, advertorial kartı; [sel, delay, stagger]
    const AUTO = [
      ['.ocx-head, .ocxl-head, .ktg-head', 0, 0], ['.ocx-img, .ocxl-img, .ktg-img', 0, 0], ['.ocx-txt, .ocxl-txt', 200, 0],
      ['.oclp-hero__media, .oclp-helps__img, .oclp-row__img, .oclp-guar > .oclp-wrap > svg, .adv-card', 0, 0],
      ['.oclp-body, .oclp-row__txt, .oclp-size__table, .oclp-gsize__table, .oclp-gsize__how, .oc-track__card', 250, 0],
      ['.oclp-gp-p, .oclp-testi', 250, 0], ['.oclp-btn, .oclp-gbtn', 450, 0], ['.oclp-trust, .oclp-cta__small', 600, 0],
      ['.oclp-checks__item, .oclp-bam__set:first-child .oclp-bam__tile', 300, 80], ['.oclp-icons__col', 300, 100],
      ['.oclp-count__grid > div, .oclp-mat__col', 0, 150], ['.oclp-faq__list > details', 200, 60], ['.oclp-tlist > li, .oclp-strip > p', 0, 70],
    ];
    const AUTO_SPLIT = ['.oclp-h, .oclp-gp-h, .oc-track__title', 100];
    root.querySelectorAll(AUTO_SPLIT[0]).forEach((el) => {
      if (el.hasAttribute('data-kt-split') || el.closest('[data-animate]')) return;
      el.setAttribute('data-kt-split', '');
      if (el.querySelector('svg, img, kt-split-words') || config.motionReduced) { el.setAttribute('data-animate', 'fade-up'); return; }
      const w = document.createElement('kt-split-words'); w.setAttribute('data-animate', 'fade-up-large'); w.setAttribute('data-animate-delay', AUTO_SPLIT[1]);
      while (el.firstChild) w.appendChild(el.firstChild); el.appendChild(w);
    });
    AUTO.forEach(([sel, delay, stagger]) => root.querySelectorAll(sel).forEach((el) => {
      if (el.hasAttribute('data-animate') || el.closest('[data-animate]')) return;
      const idx = stagger ? Array.from(el.parentElement.children).indexOf(el) : 0;
      el.setAttribute('data-animate', 'fade-up');
      const d = delay + idx * stagger; if (d) el.setAttribute('data-animate-delay', d);
    }));
    root.querySelectorAll('[data-animate]:not(kt-animate):not(kt-split-words):not([data-kt-ready])').forEach((el) => {
      el.setAttribute('data-kt-ready', '');
      const a = new Animation(el); a.beforeLoad();
      Motion.inView(el, async () => { await imageLoaded(a.media); a.load(); });
    });
    // oc-marquee: görünüm dışında dursun (Concept marquee paused)
    root.querySelectorAll('.oc-marquee:not([data-kt-ready])').forEach((el) => {
      el.setAttribute('data-kt-ready', '');
      new IntersectionObserver((es) => es.forEach((e) => el.classList.toggle('kt-paused', !e.isIntersecting)), { rootMargin: '0px 0px 50px 0px' }).observe(el);
    });
  };
  // Faz 5: mıknatıs (Concept magnet-link 10 px): header ikonları, slider okları, kapat butonları
  const MAGNET_SEL = '.header__icon--search, .header__icon--account, .header__icon--cart, .slider-button, .modal__close-button, .drawer__close, .oc-testi__dot, .slideshow__control';
  const initMagnet = (root = document) => {
    root.querySelectorAll(MAGNET_SEL + ':not([data-kt-magnet])').forEach((el) => { el.setAttribute('data-kt-magnet', ''); new Magnet(el).load(); });
  };
  const initHover = (root = document) => {
    initReveal(root);
    injectFill(root);
    initMagnet(root);
    root.querySelectorAll('.kt-hover:not([data-kt-ready])').forEach((el) => {
      el.setAttribute('data-kt-ready', '');
      new HoverFill(el).load();
      if (el.hasAttribute('data-magnet')) new Magnet(el).load();
    });
    root.querySelectorAll('.kt-highlight:not([data-kt-ready])').forEach((el) => {
      el.setAttribute('data-kt-ready', '');
      Motion.inView(el, () => el.classList.add('animate'));
    });
  };
  // İlk tur: inline başlangıç halleri yazıldıktan sonra (2 kare) CSS ön-gizlemeyi devret
  const setReady = () => document.documentElement.classList.add('kt-ready');
  const firstInit = () => {
    setTimeout(setReady, 1200);                                   // güvenlik: her durumda en geç 1.2 s
    try { initHover(); } catch (err) { console.warn('[kt] init', err); setReady(); return; }
    requestAnimationFrame(() => requestAnimationFrame(setReady));  // normal yol: inline başlangıç halleri yazıldı, 2 kare sonra devret
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', firstInit); else firstInit();
  document.addEventListener('shopify:section:load', (e) => initHover(e.target));
  // Sepet çekmecesi, quick-add, filtre gibi sonradan gelen DOM parçaları
  let moTimer; new MutationObserver(() => { clearTimeout(moTimer); moTimer = setTimeout(() => initHover(), 150); }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- 6. Sayı sayacı: <kt-counter data-duration="2">1.250</kt-counter> ---------- */
  class KtCounter extends HTMLElement {
    constructor() {
      super();
      if (config.motionReduced) return;
      !config.isTouch ? Motion.inView(this, () => this.init(), { margin: '200px 0px 200px 0px' }) : new InitWhenVisible(() => this.init());
    }
    init() {
      if (this.done) return; this.done = true;
      const m = this.textContent.trim().match(/\d+(?:[,. ]\d+)*/); if (!m) return;
      const orig = this.textContent, target = parseInt(m[0].replace(/[,. ]+/g, ''));
      Motion.animate((p) => { this.textContent = p === 1 ? orig : orig.replace(m[0], Math.round(p * target).toString()); }, { duration: parseFloat(this.getAttribute('data-duration')) || 2, easing: EASE });
    }
  }
  customElements.define('kt-counter', KtCounter);

  /* ---------- 7. Parallax: <div is="kt-parallax" data-start="-10%" data-stop="10%"> ve <kt-media data-parallax="0.3" data-parallax-dir="vertical|horizontal|zoom"> ---------- */
  class KtParallax extends HTMLDivElement {
    constructor() { super(); this.load(); window.matchMedia('(max-width: 749px)').addEventListener('change', (e) => e.matches ? this.unload() : this.load()); }
    load() { if (config.motionReduced || config.isTouch || config.mqlSmall) return; this.stop = Motion.scroll(Motion.animate(this, { transform: [`translateY(${this.getAttribute('data-start')})`, `translateY(${this.getAttribute('data-stop')})`] }), { target: this, offset: Motion.ScrollOffset.Any }); }
    unload() { if (this.stop) { this.stop(); this.style.transform = null; } }
  }
  customElements.define('kt-parallax', KtParallax, { extends: 'div' });
  class KtMedia extends HTMLElement {
    get parallax() { return parseFloat(this.getAttribute('data-parallax')) || 0; }
    get media() { return Array.from(this.querySelectorAll('picture>img, video, iframe, svg')); }
    connectedCallback() {
      if (config.motionReduced || !this.parallax) return;
      const s = 1 + this.parallax, t = this.parallax * 100 / (1 + this.parallax), dir = this.getAttribute('data-parallax-dir') || 'vertical', off = { target: this, offset: ['start end', 'end start'] };
      if (dir === 'vertical') Motion.scroll(Motion.animate(this.media, { transform: [`scale(${s}) translateY(0)`, `scale(${s}) translateY(${t}%)`], transformOrigin: ['bottom', 'bottom'] }, { easing: 'linear' }), off);
      else if (dir === 'horizontal') Motion.scroll(Motion.animate(this.media, { transform: [`scale(${s}) translateX(0)`, `scale(${s}) translateX(${t}%)`], transformOrigin: ['right', 'right'] }, { easing: 'linear' }), off);
      else Motion.scroll(Motion.animate(this.media, { transform: ['scale(1)', `scale(${s})`], transformOrigin: ['center', 'center'] }, { easing: 'linear' }), off);
    }
  }
  customElements.define('kt-media', KtMedia);

  /* ---------- 8. Kayan şerit: <kt-marquee class="kt-marquee" data-speed="15" data-direction="left" data-parallax="0.3"><div>…tek kopya…</div></kt-marquee> ---------- */
  class KtMarquee extends HTMLElement {
    constructor() {
      super();
      if (config.motionReduced) return;
      !config.isTouch ? Motion.inView(this, () => this.init(), { margin: '200px 0px 200px 0px' }) : new InitWhenVisible(() => this.init());
    }
    w(el) { const r = el.getBoundingClientRect(); return r.right - r.left; }
    init() {
      if (this.done) return; this.done = true;
      const child = this.firstElementChild, speed = parseInt(this.getAttribute('data-speed')) || 16;
      const max = parseInt(this.getAttribute('data-maximum')) || Math.ceil(this.w(this) / this.w(child)) + 2;
      if (this.childElementCount === 1) {
        child.classList.add('animate');
        for (let i = 0; i < max; i++) { const c = child.cloneNode(true); c.setAttribute('aria-hidden', 'true'); this.appendChild(c); }
        this.style.setProperty('--duration', `${(33 - speed) * Math.min(2.5, Math.ceil(this.w(child) / this.w(this)))}s`);
      }
      const p = !config.isTouch && parseFloat(this.getAttribute('data-parallax'));
      if (p) {
        let t = p * 100 / (1 + p); if ((this.getAttribute('data-direction') || 'left') === 'right') t = -t;
        Motion.scroll(Motion.animate(this, { transform: [`translateX(${t}%)`, 'translateX(0)'] }, { easing: 'linear' }), { target: this, offset: ['start end', 'end start'] });
      } else {
        new IntersectionObserver((es) => es.forEach((e) => this.classList.toggle('paused', !e.isIntersecting)), { rootMargin: '0px 0px 50px 0px' }).observe(this);
      }
    }
  }
  customElements.define('kt-marquee', KtMarquee);

  /* ---------- 9. Özel imleç + overlay tetikleyici ---------- */
  class KtCursor extends HTMLElement {
    constructor() {
      super(); if (config.isTouch) return;
      let x = 0, y = 0;
      document.addEventListener('mousemove', (e) => { x += (e.clientX - x) / 4; y += (e.clientY - y) / 4; this.style.setProperty('--x', `${x}px`); this.style.setProperty('--y', `${y}px`); });
    }
  }
  customElements.define('kt-cursor', KtCursor);
  class KtOverlay extends HTMLElement {
    constructor() {
      super(); const c = () => document.querySelector('kt-cursor');
      this.addEventListener('mousemove', () => c()?.classList.add('active'));
      this.addEventListener('mouseleave', () => c()?.classList.remove('active'));
      this.addEventListener('mousedown', () => c()?.classList.add('pressed'));
      this.addEventListener('mouseup', () => c()?.classList.remove('pressed'));
    }
  }
  customElements.define('kt-overlay', KtOverlay);
  // Faz 5: overlay/modal arka planı üstünde imleç aktif (Kaching sepet overlay'i, Dawn modal-dialog / quick-add-modal arka planı)
  const OVERLAY_SEL = '.kaching-cart__overlay, modal-dialog[open], quick-add-modal[open], .menu-drawer-container[open] > .menu-drawer';
  if (!config.isTouch) {
    const cur = () => document.querySelector('kt-cursor');
    document.addEventListener('mousemove', (e) => { const c = cur(); if (!c) return; c.classList.toggle('active', !!(e.target && e.target.matches && e.target.matches(OVERLAY_SEL))); }, { passive: true });
    document.addEventListener('mousedown', (e) => { const c = cur(); if (c && e.target.matches && e.target.matches(OVERLAY_SEL)) c.classList.add('pressed'); });
    document.addEventListener('mouseup', () => cur()?.classList.remove('pressed'));
    document.addEventListener('mouseleave', () => cur()?.classList.remove('active'));
  }

  /* ---------- 10. Yükleme çubuğu + sayfa geçiş sınıfları ---------- */
  window.addEventListener('DOMContentLoaded', () => { document.body.classList.add('loaded'); document.dispatchEvent(new CustomEvent('page:loaded')); });
  window.addEventListener('beforeunload', () => document.body.classList.add('unloading'));
  window.addEventListener('pageshow', (e) => e.persisted && document.body.classList.remove('unloading'));
  customElements.define('kt-loading-bar', class extends HTMLElement { constructor() { super(); document.addEventListener('page:loaded', () => Motion.animate(this, { opacity: 0 }, { duration: 1 }).finished.then(() => { this.hidden = true; })); } });

  /* ---------- 11. Sticky header: aşağı kaydırınca gizle ---------- */
  class KtStickyHeader extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section') || this.parentElement;
      this.b = this.section.getBoundingClientRect(); this.first = window.scrollY; this.cur = 0;
      window.addEventListener('scroll', throttle(() => this.onScroll()), { passive: true });
    }
    onScroll() {
      const s = window.scrollY, top = this.b.top + this.first, h = this.b.height;
      this.section.classList.toggle('header-scrolled', s > top + h);
      if (s > top + h + 100) this.section.classList.toggle('header-hidden', s > this.cur); else this.section.classList.remove('header-hidden');
      this.cur = s;
    }
  }
  customElements.define('kt-sticky-header', KtStickyHeader);
})();
